import { Component, CSP_NONCE, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { HttpClient } from '@angular/common/http';
import { CommonModule, Location } from '@angular/common';
import { appConfig } from '../../../app/app.config';

@Component({
  selector: 'app-energy-meter-configuration',
  templateUrl: './energy-meter-configuration.component.html',
  styleUrls: ['./energy-meter-configuration.component.scss'],
  standalone:true,
  imports: [CommonModule,FormsModule,ReactiveFormsModule],
})
export class EnergyMeterConfigurationComponent implements OnInit {

  public energyMeterAPI = BaseUrlConstantsService.energyMeterApi;
  public getGnericSerialNo = BaseUrlConstantsService.BASE_MIDDLEWARE_SELF;

  energyMeterForm: FormGroup;

  emDataPushRate = appConfig.emDataPushRate;
  public sites:any = [];
  public applications:any = [];
  public manufacturers = ['Manufacturer 1', 'Manufacturer 2', 'Manufacturer 3'];
  public countries:any= [];
  public countryData:any = [];
  public availableDeviceData:any = [];
  public deviceData:any = [];
  public states:any = [];
  public statesData:any = [];
  public userID: any=0;
  public deviceName:String="";
  public selectedCountry: number;
  public selectedState: number;
  public countryStateData:any = [];
  public pageType: string;
  public editDataObj: any;
  public showUpdateBtn: boolean=false;
  public showButtontxt:string='Save Energymeter';
  public title:string='Add Energymeter';
  public serial_number:string='0';
  public gateway_address:string='0';
  public subsystemID:any=0;
  public clientEmRelationID:any=0;
  public deviceID:number=0;
  public gw_deivce_id:number=0;
  public gw_deivcetype_id:number=0;
  public connection_number:number=0;

  public gatewayDeviceData:any =[];
  public gatewayid:number=5;

  public gatewayMacAddressDeviceData:any=[];
  public macAddress:String="";
  public generic_asset_id: any =0;
  public selected_Macaddress: any;
  public genericSerialNo: string;
  newgenericSerialNo: string;
  public product_type_id = 3;
  countTouch: number =0;
  meter_device_id: any;
  selected_Macaddress_id: any;



  constructor(private fb: FormBuilder, public service: BackendApiService, private http: HttpClient, public router: Router,private activeRoute: ActivatedRoute, private location: Location) {

    if(localStorage.getItem('role') === 'CLIENT'){
      this.userID = localStorage.getItem('user_id');
    }else if(localStorage.getItem('role') === 'ADMIN'){
      if(localStorage.getItem('admin_client_id') !== '' && localStorage.getItem('admin_client_id') !== undefined && localStorage.getItem('admin_client_id') !== null && parseInt(localStorage.getItem('admin_client_id')) > 0 ){
        this.userID = localStorage.getItem('admin_client_id');
      }
    }
    console.log(this.emDataPushRate,'emDataPushRateemDataPushRate')

    this.energyMeterForm = this.fb.group({
      client_id: [this.userID],
      subsystem: ['', Validators.required],
      name: [''],
      serialNumber: [''],
      gn_serial_number: [''],
      site: ['', Validators.required],
      application: ['', Validators.required],
      manufacturer: [''],
      address: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      latitude: ['', [Validators.required, Validators.pattern(/^-?\d+(\.\d+)?$/)]],
      longitude: ['', [Validators.required, Validators.pattern(/^-?\d+(\.\d+)?$/)]],
      gw_devicetype_id: ['', [Validators.required, Validators.pattern(/^-?\d+(\.\d+)?$/)]],
      gw_device_id: ['', [Validators.required, Validators.pattern(/^-?\d+(\.\d+)?$/)]],
      gateway_address: ['', Validators.required],
      energymeter_data_push_rate: ['', Validators.required]
    });

  }
  
  ngOnInit(): void {
    
    // Use history.state to retrieve the data passed via the router
    this.editDataObj = history.state.configratorObj;
    console.log(this.editDataObj,'dddddddddd')
    if (this.editDataObj) {
      this.generic_asset_id = this.editDataObj.generic_asset_id;
      this.pageType = this.editDataObj.pageType;
      this.serial_number = this.editDataObj.serial_number;
      this.gateway_address = this.editDataObj.gateway_address;

      // Check if the pageType is 'edit-configrator' to switch between edit and create modes
      if (this.pageType === 'edit-configrator') {

        this.editDataObj = this.editDataObj; // Set the edit object data
        this.showUpdateBtn = true; // Show the update button
        this.showButtontxt = 'Save Energymeter';
        // this.title = 'Edit Energymeter';
        this.title = 'Energymeter Details';

        
      } else {
        this.showUpdateBtn = false; // Show the create button
        this.showButtontxt = 'Save Energymeter';
        this.title = 'Add Energymeter';
      }
    } else {
      console.log('No state data found in history.state');
    }
    this.getPreviousSerialNo();
    // Any initialization logic can be placed here
    this.getCountries();
    this.getEnergymeterAllSites(this.userID);
    this.getAvailableDevices(this.userID,this.generic_asset_id);

    if (this.pageType === 'edit-configrator') {

      this.getEnergymeterAllSiteById(this.editDataObj.site_id);
      //this.getApplicationsBySiteID(this.editDataObj.site_id);
      this.energyMeterForm.patchValue({
        site: this.editDataObj.site_id,
        application: this.editDataObj.application_id        
      });
     
      //Fetch subsystem name by site_id, application_id & serial_number for edit Configrator case.
      this.service.getData( this.energyMeterAPI +  "/get-subsystem-name/" + this.editDataObj.site_id + "/" + this.editDataObj.application_id+ "/" + this.userID).then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {

          let getSubsystemNameRes = JSON.parse(JSON.stringify(res)).data.body;   
          this.energyMeterForm.patchValue({
            subsystem: getSubsystemNameRes[0].subsystem_name,
            subsystem_id:getSubsystemNameRes[0].subsystem_id,
            clientemrelation_id:getSubsystemNameRes[0].client_em_relation_id,
            energymeter_data_push_rate:getSubsystemNameRes[0].energymeter_data_push_rate
          });
          this.subsystemID = getSubsystemNameRes[0].subsystem_id;
          this.clientEmRelationID = getSubsystemNameRes[0].client_em_relation_id;          
        } 
       
      });

      //Fetch Gateway Detail.
      this.service.getData( this.energyMeterAPI +  "/get-gateway-info/" + this.editDataObj.gateway_address).then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {

          let getGatewayInfoRes = JSON.parse(JSON.stringify(res)).data.body;  
          this.getGatewayById(getGatewayInfoRes[0].device_id);

          // Delay the next code block by one second (1000 ms)
          setTimeout(() => {
              this.energyMeterForm.patchValue({
                  gw_devicetype_id: getGatewayInfoRes[0].device_id,
                  gw_device_id: getGatewayInfoRes[0].device_inventory_id,
                  gateway_address:this.editDataObj.gateway_address
              });
          }, 1000); // 1000 milliseconds = 1 second

                  
        } 
       
      });

     
    }

    if (this.pageType === 'edit-configrator') {
      this.energyMeterForm.get('serialNumber').disable();
      this.energyMeterForm.get('gn_serial_number').disable();
      this.energyMeterForm.get('subsystem').disable();
      this.energyMeterForm.get('gw_devicetype_id').disable();
      this.energyMeterForm.get('gw_device_id').disable();
      this.energyMeterForm.get('site').disable();
      this.energyMeterForm.get('application').disable();
    } else {
      this.energyMeterForm.get('serialNumber').enable();
      this.energyMeterForm.get('gn_serial_number').enable();
      this.energyMeterForm.get('gw_devicetype_id').enable();
      this.energyMeterForm.get('gw_device_id').enable();
      this.energyMeterForm.get('site').enable();
      this.energyMeterForm.get('application').enable();
    }

    this.getGatewayDevices(5);
  }

  goBack(): void {
    if(this.title=='Add Energymeter'){
      if(localStorage.getItem('role') === 'CLIENT'){
        //this.location.back();
        const navigationExtras = { 
          skipLocationChange: true,    
          queryParams: {          
            tabName:"tab-1"
          },
        };
  
        this.router.navigate(["/device-reports"], navigationExtras);
      }
      if (localStorage.getItem('role') === 'ADMIN') {
        const navigationExtras = {
          skipLocationChange: true,
          queryParams: {
            assetsFilterName: "ALL",
            admin_client_id: localStorage.getItem('admin_client_id'),
            clientName: localStorage.getItem('admin_client_name'),
            pageRef: "AdminClientPage",
            tabName: "tab-3"
          }
        };
      
        this.router.navigate(['/device-report-new'], navigationExtras);
      }
    }else{
      if(localStorage.getItem('role') === 'CLIENT'){
        //this.location.back();
        const navigationExtras = { 
          skipLocationChange: true,    
          queryParams: {          
            tabName:"tab-3",
            toggle:'true'
          },
        };
  
        this.router.navigate(["/device-reports"], navigationExtras);
      }
  
      if (localStorage.getItem('role') === 'ADMIN') {
        const navigationExtras = {
          skipLocationChange: true,
          queryParams: {
            assetsFilterName: "ALL",
            admin_client_id: localStorage.getItem('admin_client_id'),
            clientName: localStorage.getItem('admin_client_name'),
            pageRef: "AdminClientPage",
            tabName: "tab-3",
            toggle:'true'
          }
        };
      
        this.router.navigate(['/device-report-new'], navigationExtras);
      }
      
    }
    
  }
  
  getCountries(){   
    this.service.getDataWithQuery(this.energyMeterAPI+"/energymeter-all-country/").then((sRes) => {
           
      let countryRes= JSON.parse(JSON.stringify(sRes)).data;      
      
        if (countryRes.body && Object.keys(countryRes.body).length !== 0) {
        
          let response = countryRes.body;
          
          this.countries =[];

          if (response != undefined){

            if(response.length != 0){

              this.countryData= response;

              if (this.countryData.length !== 0) {
                            
                for (let mCount = 0; mCount < this.countryData.length; mCount++) {

                  let id="";
                  let name = "";
                  let country_code = "";
                  let currency = "";

                  id = this.countryData[mCount].id;
                  name = this.countryData[mCount].name;
                  country_code = this.countryData[mCount].country_code;
                  currency = this.countryData[mCount].currency;

                  const countryListingsData = {
                    // value:value,
                    id: id,
                    name:  name,
                    country_code:  country_code,
                    currency:  currency                    
                  };

                  this.countries.push(countryListingsData);

                }
                

              }

            }
                
          }

        }
    });
  }

  onCountryChange(countryID){
    this.service.getDataWithQuery(this.energyMeterAPI+"/energymeter-state-by-id/"+countryID).then((sRes) => {
           
      let stateRes= JSON.parse(JSON.stringify(sRes)).data;      
      
        if (stateRes.body && Object.keys(stateRes.body).length !== 0) {
        
          let response = stateRes.body;
          
          this.states =[];

          if (response != undefined){

            if(response.length != 0){

              this.statesData= response;

              if (this.statesData.length !== 0) {
                            
                for (let mCount = 0; mCount < this.statesData.length; mCount++) {

                  let id="";
                  let name = "";

                  id = this.statesData[mCount].id;
                  name = this.statesData[mCount].name;

                  const stateListingsData = {                 
                    id: id,
                    name:  name                  
                  };

                  this.states.push(stateListingsData);

                }
                

              }

            }
                
          }

        }
            
    });
  }

  getEnergymeterAllSites(id){
   
    this.service.getData(this.energyMeterAPI+'/clientsites/'+id).then((res) => {
     
      if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        this.sites = JSON.parse(JSON.stringify(res)).data.body.result2;
        
      }
    });

  }

  getEnergymeterAllSiteById(siteId){

    this.service.getData( this.energyMeterAPI +  "/client-all-sites/" + this.userID +   "/" +   siteId ).then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {

          // Get All Applications.
          this.getApplicationsBySiteID(siteId);

          let siteAddressData = JSON.parse(JSON.stringify(res)).data.body;

          this.selectedCountry = siteAddressData[0].country_fk;
          this.onCountryChange(this.selectedCountry);
          setTimeout(() => {
            this.selectedState = siteAddressData[0].state_fk;
          }, 2000);

          this.energyMeterForm.patchValue({
            latitude: siteAddressData[0].latitude,
            longitude: siteAddressData[0].longitude,
            address: siteAddressData[0].address_1
          });

        } 
      });
   
  }

  getApplicationsBySiteID(siteId){

    this.service.getData( this.energyMeterAPI +  "/client-applications-by-sitesid/" + this.userID +   "/" +   siteId ).then((res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        this.applications = JSON.parse(JSON.stringify(res)).data.body;

        
        if (this.pageType === 'edit-configrator') { 


          this.onApplicationSelect(this.editDataObj.application_id);
        }
      } 
    });
  }


   getPreviousSerialNo(){
      this.service.getData(`${this.getGnericSerialNo}generic_asset/${this.product_type_id}`)
      .then((res:any) =>{
        let response = res.data;
        if(response.status === "success"){
            if(response.body?.body?.length === 0){
              this.genericSerialNo = "";
            }else{
              this.genericSerialNo = response.body.device_sno;
            }
        }else{
          this.genericSerialNo = "";
        }
      })
  }

  getAvailableDevices(client_id,generic_asset_id){

    this.service.getData( this.energyMeterAPI +  "/energymeter-available-devices/" + client_id + "/" + generic_asset_id).then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          this.availableDeviceData = JSON.parse(JSON.stringify(res)).data.body;   
         
          if (this.pageType !== 'edit-configrator') {

            this.energyMeterForm.patchValue({
              serialNumber: this.editDataObj.serial_number      
            });
            this.onSelectSerailNumber(this.editDataObj.serial_number);
          }else{
            this.energyMeterForm.controls['serialNumber'].setValue(this.availableDeviceData[0].name);
            this.newgenericSerialNo = this.availableDeviceData[0].device_sno;
            this.deviceName =this.availableDeviceData[0].name;
          }
        } 
       
      });

  }

  onSelectSerailNumber(deviceID){
     console.log(deviceID)
      const selectedMac = deviceID; // just the MAC string
      this.newgenericSerialNo = this.genericSerialNo;
      console.log("Updated Serial:", this.newgenericSerialNo,selectedMac);
    console.log(this.availableDeviceData,'this.availableDeviceData')
     const selecedtMacaddressObj = this.availableDeviceData.find(
        g => g.mac_address === selectedMac
      );
      console.log(selecedtMacaddressObj,'sssssssssssssssss')
      this.deviceName = selecedtMacaddressObj.name;
      this.meter_device_id = selecedtMacaddressObj
      console.log(selecedtMacaddressObj,'selectmac')
       this.selected_Macaddress_id = selecedtMacaddressObj.id;
       console.log(this.selected_Macaddress_id,'selected_Macaddress_id')
      let selectedAbbr = selecedtMacaddressObj.abbreviation;
      if (!this.genericSerialNo || this.genericSerialNo === "") {
        // First time → start fresh
        this.genericSerialNo = selectedAbbr + "MA01";
      } else {
        // Example current: RIOA01 → want only prefix(2) + letter + number
        let letter = this.genericSerialNo.charAt(this.genericSerialNo.length - 3); // "A"
        let number = parseInt(this.genericSerialNo.slice(-2), 10);                 // 01
        if(this.countTouch == 0){
          if (number < 99 ) {
            number++;
            this.genericSerialNo =
              selectedAbbr +"M"+ letter + number.toString().padStart(2, "0");
          } else {
            // rollover case: XX...A99 → XX...B01
            let nextLetter = String.fromCharCode(letter.charCodeAt(0) + 1);
            this.genericSerialNo = selectedAbbr +"M"+ nextLetter + "01";
          }
        } 
        this.countTouch++;
      }
       this.newgenericSerialNo = this.genericSerialNo;
      console.log("Updated Serial:", this.newgenericSerialNo);
     
      // if(element.mac_address==deviceID){
      //   this.deviceName = element.name;
        // this.deviceID = element.device_type_id;
        // this.gw_deivcetype_id = element.device_type_id;
        // this.gw_deivce_id = element.id;

        // this.service.getData( this.energyMeterAPI +  "/get-devices-by-id/" + this.deviceID).then((res) => {
        //   if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        //     this.deviceData = JSON.parse(JSON.stringify(res)).data.body;
            
        //     if(this.deviceData.length >0){
             
        //     }
           
            
        //   } 
         
        // });


      // }

  }

  onSelectDevice(devicyTypeID){
    console.log(this.gatewayMacAddressDeviceData,'gatewayMacAddressDeviceDatagatewayMacAddressDeviceData');
    this.gatewayMacAddressDeviceData.forEach(element => {

      if(element.id==devicyTypeID){
        this.energyMeterForm.patchValue({
          gateway_address: element.mac_address
        });         
      }

    });

  }

  onApplicationSelect(applicationID){
    const selectedApplication = this.applications.find(app => app.id == applicationID);
  }

  getGatewayDevices(gatewayid){

    this.service.getData( this.energyMeterAPI +  "/get-devices-by-deviceCategoryId/" + gatewayid).then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          let gatewayDeviceDataResponse = JSON.parse(JSON.stringify(res)).data.body;   
         
          if(gatewayDeviceDataResponse.length >0 ){

            this.gatewayDeviceData = gatewayDeviceDataResponse;
          }
          
        } 
       
      });
  }

  getGatewayById(gateway_id){

    this.service.getData( this.energyMeterAPI +  "/get-gateway-macaddresses/" + gateway_id+"/"+this.userID).then((res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        let gatewayMacAddressesDataResponse = JSON.parse(JSON.stringify(res)).data.body;   
       
        if(gatewayMacAddressesDataResponse.length >0 ){

          this.gatewayMacAddressDeviceData = gatewayMacAddressesDataResponse;
        }
        
      } 
     
    });
  }
  onSubmit() {
    this.energyMeterForm.controls['name'].enable();
    this.energyMeterForm.controls['name'].setValue(this.deviceName);
    this.energyMeterForm.controls['latitude'].enable();
    this.energyMeterForm.controls['longitude'].enable();
    this.energyMeterForm.controls['address'].enable();
    this.energyMeterForm.controls['country'].enable();
    this.energyMeterForm.controls['state'].enable();
    this.energyMeterForm.controls['gw_device_id'].enable();
    this.energyMeterForm.controls['gw_devicetype_id'].enable();
    this.energyMeterForm.controls['gateway_address'].enable();
    this.energyMeterForm.controls['energymeter_data_push_rate'].enable();
    this.energyMeterForm.controls['gn_serial_number'].setValue(this.newgenericSerialNo);
   const payload = {
  ...this.energyMeterForm.value,
     selected_macaddress_id: this.selected_Macaddress_id
  };
    if (this.energyMeterForm.valid) {

      this.service.saveSettings(this.energyMeterAPI+"/emeter-subsystem-save",payload).then((sRes) => {
     

        if (JSON.parse(JSON.stringify(sRes)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(sRes)).data.message;

          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(sRes)).data.status === 'error') {
          const msgErr = JSON.parse(JSON.stringify(sRes)).data.message;

          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(sRes)).data.status === 'success') {

            this.service.showSuccess('Configurator registered successfully');
            this.router.navigate(['/device-reports']);
        } else {
          this.service.showError('Something went wrong.');
        }

      }, error => {
        console.log('Error saving settings:', error);
      });


    } else {
      this.markAllAsTouched();
      console.log('Form not valid!');
    }
  }

  onUpdate(){
    
      if (this.energyMeterForm.valid) {
        
        this.service.saveSettings(this.energyMeterAPI+"/emeter-subsystem-update/"+this.subsystemID+"/"+this.clientEmRelationID,this.energyMeterForm.value).then((sRes) => {
       
  
          if (JSON.parse(JSON.stringify(sRes)).data.status === 'fail') {
            const msgErr = JSON.parse(JSON.stringify(sRes)).data.message;
  
            this.service.showError(msgErr);
          } else if (JSON.parse(JSON.stringify(sRes)).data.status === 'error') {
            const msgErr = JSON.parse(JSON.stringify(sRes)).data.message;
  
            this.service.showError(msgErr);
          } else if (JSON.parse(JSON.stringify(sRes)).data.status === 'success') {
  
              this.service.showSuccess('Configurator edit successfully');
              // if(localStorage.getItem('role') ==='ADMIN'){
              //   this.router.navigate(['/device-report-new']);
              // }else{
              //   this.router.navigate(['/device-reports']);
              // }
              if(localStorage.getItem('role') === 'CLIENT'){
                //this.location.back();
                const navigationExtras = { 
                  skipLocationChange: true,    
                  queryParams: {          
                    tabName:"tab-3"
                  },
                };
          
                this.router.navigate(["/device-reports"], navigationExtras);
              }
          
              if (localStorage.getItem('role') === 'ADMIN') {
                const navigationExtras = {
                  skipLocationChange: true,
                  queryParams: {
                    tabName: "tab-3"
                  }
                };
              
                this.router.navigate(['/device-report-new'], navigationExtras);
              }
              
              
          } else {
            this.service.showError('Something went wrong.');
          }
  
        }, error => {
          console.log('Error saving settings:', error);
        });
  
  
      } else {
        this.markAllAsTouched();
        console.log('Form not valid!');
      }
  }

  getDataPushRate(event){
    
    console.log(event,'event.target.value')
    const selectedEmDataPushRate = event;
    
  }

  markAllAsTouched() {
    Object.keys(this.energyMeterForm.controls).forEach(field => {
      const control = this.energyMeterForm.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  get name() { return this.energyMeterForm.get('name'); }
  get subsystem() { return this.energyMeterForm.get('subsystem'); }
  get serialNumber() { return this.energyMeterForm.get('serialNumber'); }
  get gn_serial_number() {return this.energyMeterForm.get('gn_serial_number'); }
  get site() { return this.energyMeterForm.get('site'); }
  get application() { return this.energyMeterForm.get('application'); }
  get manufacturer() { return this.energyMeterForm.get('manufacturer'); }
  get address() { return this.energyMeterForm.get('address'); }
  get state() { return this.energyMeterForm.get('state'); }
  get country() { return this.energyMeterForm.get('country'); }
  get latitude() { return this.energyMeterForm.get('latitude'); }
  get longitude() { return this.energyMeterForm.get('longitude'); }
  get gw_devicetype_id() { return this.energyMeterForm.get('gw_devicetype_id'); }
  get gw_device_id() { return this.energyMeterForm.get('gw_device_id'); }
  get energymeter_data_push_rate() { return this.energyMeterForm.get('energymeter_data_push_rate'); }

}
